import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { AuthRouterObserver } from "@/auth/AuthObserver";
import { devLogger } from "@/utils/devLogger";

const TANSTACK_DEV_TOOLS = import.meta.env.VITE_TANSTACK_DEV_TOOLS === "true";

export const rootRoute = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  loader: () => {
    devLogger.log("🔆Loader in rootRoute");
  },
  component: function RootRoute() {
    devLogger.log("✳️Rendering rootRoute");

    return (
      <>
        <Outlet />
        {TANSTACK_DEV_TOOLS && (
          <TanStackRouterDevtools position="bottom-right" />
        )}
        {TANSTACK_DEV_TOOLS && (
          <ReactQueryDevtools buttonPosition="bottom-left" />
        )}
        <AuthRouterObserver />
      </>
    );
  }
});
